export const LINKS = {
  header_logo: "https://www.tisbest.org",
  footer_faq: "https://www.tisbest.org/FAQ/",
  footer_phone: "tel:(206) 501-3005",
  footer_email: "mailto:info@tisbest.org",
  share_facebook:
    "https://www.tisbest.org/social/tisbest-gift-card-for-animals.html",
  share_twitter: "https://tisbest.org/",
  share_instagram: "https://www.instagram.com/tisbestcards",
  share_linkedin: "https://tisbest.org/",
};

export const IMAGES = {
  header_logo: {
    src: "https://devtisbestdata.blob.core.windows.net/images/logo.png",
    alt: "TisBest",
  },
  card_code_input_banners: [
    {
      src: "https://devtisbestdata.blob.core.windows.net/images/banner01.jpg",
      alt: "Animals",
    },
  ],
  share_banners: [
    {
      src: "https://devtisbestdata.blob.core.windows.net/images/banner01.jpg",
      alt: "Animals",
    },
  ],
  share_facebook: {
    src: "https://devtisbestdata.blob.core.windows.net/images/facebook.png",
    alt: "Facebook",
  },
  share_twitter: {
    src: "https://devtisbestdata.blob.core.windows.net/images/twitter.png",
    alt: "Twitter",
  },
  share_instagram: {
    src: "https://devtisbestdata.blob.core.windows.net/images/instagram.png",
    alt: "Instagram",
  },
  share_linkedin: {
    src: "https://devtisbestdata.blob.core.windows.net/images/linkedin.png",
    alt: "LinkedIn",
  },
};

export const DICTIONARY = {
  header_donation: "Donation Amount:",
  footer_faq: "FAQ",
  footer_contact: "Contact Us:",
  footer_phone: "(206) 501-3005",
  footer_email: "info@tisbest.org",
  footer_message: "TisBest is a registered 501(c)3 nonprofit organization.",
  footer_register: "2020 TisBest. All rights reserved.",
  guidance_header: "Which Charity Should I Choose?",
  guidance_message:
    "With so many amazing organizations to choose from, it can be a real challenge to pick a charity to support. When trying to narrow it down, ask yourself:",
  guidance_question_one: "What positive impact would I like to make?",
  guidance_question_two:
    "Is there a particular challenge, population, or region I'd like to help?",
  guidance_question_three:
    "How would I like the world to be better, and what charities work toward that goal?",
  selected_charities_header: "Selected Charities",
  selected_charities_optional: "(Optional)",
  selected_charities_required: "Please select a charity",
  selected_charities_continue: "Continue",
  category_navigation_header: "Charity Categories:",
  card_code_input_message:
    "<div>Spend your TisBest Charity Gift Card and help make the world a better place.<div style='font-size: .8em; margin-top: 10px; margin-bottom: 2px;'>1. Enter Your 6-Digit Code</div><div style='font-size: .8em;'>2. Choose Your Charities</div><div>",
  card_code_input_code: "Charity Gift Card Code",
  card_code_input_email: "Your Email Address",
  card_code_input_continue: "Continue",
  category_selector_header: "Choose a Category",
  category_selector_search_all: "Search All U.S. Charities",
  featured_charity_selector_select: "Select",
  featured_charity_selector_unselect: "Selected",
  featured_charity_selector_disabled: "Charity Limit Reached",
  national_charity_selector_header: "Search All U.S. Charities",
  national_charity_selector_search: "Search",
  national_charity_selector_select: "Select",
  national_charity_selector_unselect: "Selected",
  national_charity_selector_disabled: "Charity Limit Reached",
  national_charity_selector_query_label: "Keyword or Charity Name",
  national_charity_selector_postal_label: "Zip",
  national_charity_selector_category_label: "Charity Category",
  national_charity_selector_results_label: "results",
  national_charity_selector_open_filter: "Open Filter",
  national_charity_selector_close_filter: "Close Filter",
  charity_distribution_header: "Review Your Selections",
  charity_distribution_message:
    "We will distribute your donation amount evenly across your charities, or you can customize the amount each charity will receive.",
  charity_distribution_donation_amount: "Donation Amount:",
  charity_distribution_note: "Note: There is a $3 minimum per charity",
  charity_distribution_stay_informed:
    "Please let these charities know I donated, and ask them to keep me informed about their work.",
  charity_distribution_input_name: "Name",
  charity_distribution_input_email: "Email",
  charity_distribution_continue: "Continue",
  charity_distribution_back: "Edit Selections",
  charity_distribution_reset: "Reset",
  thank_you_header: "Thank Your Gifter",
  thank_you_message:
    "TisBest will send an email to the person who gave you this Charity Gift Card confirming your donations. We’re happy to include a Thank You Note in that email if you like.",
  thank_you_input_thank_you_name: "Your Name",
  thank_you_input_thank_you_note: "Thank You Note",
  thank_you_input_thank_you_note_value:
    "Thank you for the TisBest Charity Gift Card! It means a lot to me to be able to help change the lives of many, making this world a better place.",
  thank_you_continue: "Donate and Send Note",
  thank_you_skip: "Donate Without Sending a Note",
  share_header_plural: "Confirmed!",
  share_header_single: "Confirmed!",
  share_message_plural: "Your contribution makes the world a better place.",
  share_message_single: "Your contribution makes the world a better place.",
  share_call_to_action: "Now share the feeling!",
  share_information_plural:
    "Let your friends know what you chose! It's easy to share this moment on all your favorite feeds:",
  share_information_single:
    "Let your friends know what you chose! It's easy to share this moment on all your favorite feeds:",
  share_facebook: "TisBest is a better gift for a better world.",
  share_twitter: "TisBest is a better gift for a better world.",
  share_instagram: "TisBest is a better gift for a better world.",
  share_linkedin: "TisBest is a better gift for a better world.",
  share_tip:
    "(Tip: Give your charities some extra love by @ tagging them in your post!)",
  code_error_header: "Your card has been successfully donated!",
  code_error_message: "",
  code_error_header_spent:
    "TisBest Charity Gift Card [CODE] was spent on [DATESPENT] to support:",
  code_error_message_spent: "",
  code_error_information:
    "<div>If we have any additional information on your card code, we will send you an email with details. Please check your inbox, and contact us at <a href='mailto:info@tisbest.org'>info@tisbest.org</a> or <a href='tel:2065013005'>(206)501-3005</a> if you have questions.</div>",
  campaign_welcome_continue: "Continue",
  campaign_instructions_header: "Special Instructions (Optional)",
  campaign_instructions_message:
    "If you have any special instructions for your donation, you can select an option below. Or just click continue and we will send a check to your charit(ies) with no special instructions.",
  campaign_instructions_continue: "Continue",
  campaign_instructions_no_instructions:
    "Please send a check to my selected charity(ies) with no special instructions",
  campaign_instructions_paper_check:
    "Please send me a paper check to hand deliver to my selected charity(ies)",
  campaign_instructions_particular_program:
    "Please direct the donation to a particular program at my selected charity(ies)",
  campaign_instructions_particular_person:
    "Please make the donation in the name of a particular person",
  campaign_instructions_other: "Other",
  campaign_instructions_address: "Address",
  campaign_instructions_address2: "Address 2",
  campaign_instructions_city: "City",
  campaign_instructions_state: "State",
  campaign_instructions_zip: "Zip",
  campaign_instructions_notes: "Special Instructions",
  campaign_instructions_name: "Name",
  campaign_instructions_phone: "Phone",
  campaign_instructions_email: "Email",
  campaign_thank_you_header: "Thank You",
  campaign_thank_you_continue: "Continue",
  suggested_charity_selector_select: "Select",
  suggested_charity_selector_unselect: "Unselect",
};

export const VALIDATION = {
  card_code_input_code:
    "<div style='margin-bottom: 5px;'>Oops! Something went wrong with your Charity Gift Card code. Please double check that you've entered it correctly.</div><div>You can contact us at <a href='mailto:info@tisbest.org'>info@tisbest.org</a> or <a href='tel:2065013005'>(206)501-3005</a> if you have questions.</div>",
  card_code_input_email: "Please use a valid email address.",
  charity_distribution_input_name: "Please use a valid name.",
  charity_distribution_input_email: "Please use a valid email address.",
  charity_distribution_input_total_high:
    "You have exceeded the {Total} on the card by {Difference}",
  charity_distribution_input_total_low:
    "You still have {Difference} to spend out of {Total}",
  charity_distribution_input_total_out_of_bounds:
    "You must assign at least $3 to all selected charities",
  thank_you_input_thank_you_name:
    "Please add your name to include your thank you note or select “Donate Without Sending a Note”.",
  thank_you_input_thank_you_note:
    "Please add a message or select “Donate Without Sending a Note”.",
  campaign_instructions_address: "Please use a valid address",
  campaign_instructions_address2: "Please use a valid address",
  campaign_instructions_city: "Please use a valid city",
  campaign_instructions_state: "Please use a valid state",
  campaign_instructions_zip: "Please use a valid zip",
  campaign_instructions_notes: "Please use special instructions",
  campaign_instructions_name: "Please use a valid name",
  campaign_instructions_phone: "Please use a valid phone",
  campaign_instructions_email: "Please use a valid email",
};
